module.exports = __webpack_public_path__ + "static/media/Warrior_Protection.d18d478b.jpg";